<template>
    <div class="vx-col md:w-1/1 w-full">
        <vx-card title="Sales Order">
            <div class="vx-row mb-6" style="width:50%">
                <div class="vx-col sm:w-1/3 w-full flex items-center">
                    <span>Territory</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    <multiselect
                        class="selectExample"
                        v-model="territory"
                        :options="optionTerritory"
                        :multiple="true"
                        :allow-empty="false"
                        :group-select="false"
                        :max-height="100"
                        placeholder="Type to search"
                        track-by="code"
                        label="name"
                    >
                        <template slot="singleLabel" slot-scope="props">
                            <span class="option__desc">
                                <span class="option__title">{{ props.option.code }} {{ props.option.name }}</span>
                            </span>
                        </template>
                        <template slot="option" slot-scope="props">
                            <div class="option__desc">
                                <span class="option__title">{{ props.option.code }} {{ props.option.name }}</span>
                            </div>
                        </template>
                    </multiselect>
                </div>
            </div>
            <div class="vx-row mb-6" style="width:50%">
                <div class="vx-col sm:w-1/3 w-full flex items-center">
                    <span>Start Date</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    <datepicker :inline="false" v-model="startDate" placeholder="Select Date (Created at)"></datepicker>
                </div>
            </div>
            <div class="vx-row mb-6" style="width:50%">
                <div class="vx-col sm:w-1/3 w-full flex items-center">
                    <span>End Date</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    <datepicker :inline="false" v-model="endDate" placeholder="Select Date (Created at)"></datepicker>
                </div>
            </div>
            <div class="vx-row mb-6" style="width:50%">
                <div class="vx-col sm:w-1/3 w-full flex items-center">
                    <span>Sales Order Number</span>
                </div>
                <div class="vx-col sm:w-2/3 w-full">
                    <vue-tags-input
                        v-model="so_number"
                        :tags="so_numbers"
                        placeholder="search by code"
                        @tags-changed="(newValues) => (so_numbers = newValues)"
                    />
                </div>
            </div>
            <div class="vx-row mb-6" style="width:50%">
                <div class="vx-col sm:w-1/3 w-full flex items-center">
                    <vs-button class="float-left" color="primary" @click="handleFilters()">
                        Filter
                    </vs-button>
                </div>
            </div>
            <br>
            <vs-tabs :color="colorx">
                <vs-tab @click="function(){
                    colorx = 'success';
                    filter = 0;
                }" label="New">
                    <div class="con-tab-ejemplo">
                        <br>
                        <newSO :so_numbers_str="so_numbers_str" :territory="territory_codes" :startDate="startDate" :endDate="endDate" :filter="filter"></newSO>
                    </div>
                </vs-tab>
                <vs-tab @click="function(){
                    colorx = 'warning';
                    filter = 0;
                }" label="Released">
                    <br>
                    <releasedSO :so_numbers_str="so_numbers_str" :territory="territory_codes" :startDate="startDate" :endDate="endDate" :filter="filter"></releasedSO>
                </vs-tab>
            </vs-tabs>
        </vx-card>
    </div>
</template>

<script>
import newSO from "./new_so/datatable.vue";
import releasedSO from "./released_so/datatable.vue";
import Datepicker from "vuejs-datepicker";
import VueTagsInput from "@johmun/vue-tags-input";

export default {
    components: {
        newSO,
        releasedSO,
        Datepicker,
        VueTagsInput
    },
    mounted() {
        let terr_params = null;
        if (this.$userLogin.territory_id != 0) {
			terr_params = { 
				params : {
					id : this.$userLogin.territory_id,
				},
			};
            this.getOptionTerritory(terr_params);
		} else {
            this.getOptionTerritory();
        }
        console.log("this.$userLogin", this.$userLogin);
        console.log("terr_params", terr_params);
    },
    data: () => ({
        territory: [{
            id:0,
            code:"",
            name:"ALL"
        }], //{ text: "Malang Raya", value: 1 },
        optionTerritory: [{}],
        territory_codes:"",
        colorx: "success",
        startDate: "",
        endDate: "",
        filter:0,
        so_numbers:[],
        so_numbers_str:"",
        so_number:"",
    }),
    watch: {
        territory: function(newValue) {
            if (newValue&&newValue.length>0) {
                if (newValue.length>1&&newValue[newValue.length-1].id == 0) {
                    this.territory = [newValue[newValue.length-1]] // hati-hati bisa menyebabkan infinite loop
                }else{
                    var allExist = false
                    if (newValue.length>1) {
                        newValue =  newValue.filter((v)=>{
                            if (v.id == 0) {
                                allExist = true
                            }
                            return v.id != 0
                        })
                    }
                    if (allExist) {
                        this.territory = newValue // hati-hati bisa menyebabkan infinite loop
                    }
                }
            }
        }
    },
    methods: {
        getOptionTerritory(params = null) {
            this.$http.get("/api/v1/master/territory", params).then(resp => {
                this.optionTerritory = resp.data.records;
                if (this.optionTerritory&& this.optionTerritory.length>0) {
                    this.optionTerritory.unshift({
                    id:0,
                    code:"",
                    name:"ALL"
                })
                }
                this.territory = [{
                    id:0,
                    code:"",
                    name:"ALL"
                }];
            });
        },
        handleFilters(){
            var territory_codes = this.territory.map(t => t.code);
            this.territory_codes = territory_codes.join(";");
            if (this.territory_codes=="") {
                this.territory_codes = "all";
            }
            var sonumbers =this.so_numbers.map(so => so.text);
            console.log("this.so_numbers",sonumbers);
            // if (sonumbers&&sonumbers.length>0) {
            this.so_numbers_str = sonumbers.join(";");
            // }
            this.filter++;
        }
    }
};
</script>

<style scoped>
.vs-collapse-item--content {
  height: 100%;
  max-height: 14444px;
}
</style>